import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training-record-from',
  templateUrl: './training-record-from.component.html',
  styleUrls: ['./training-record-from.component.css']
})
export class TrainingRecordFromComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Training/training-record/training-record-from/training-record-from.component.ts